import axios from 'axios';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { toast } from 'react-toastify';
import { IMeeting } from '../../../../../types';

interface ISettingsProps {
  meeting: IMeeting;
  onChange: () => void;
}

const Settings = ({ meeting, onChange }: ISettingsProps) => {
  const handleParametersChange = (type: 'block_responses' | 'block_candidacies' | 'candidate_once') => () => {
    const updatedParameters = meeting.parameters;
    updatedParameters.global[type] = !meeting.parameters.global[type];

    axios
      .put(`/api/meeting/${meeting._id}/parameters`, updatedParameters)
      .then(() => {
        onChange();
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between">
        <Col>Settings</Col>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <Form.Check
              type="switch"
              id="block-responses"
              label="Lock responses"
              checked={meeting.parameters.global.block_responses ?? false}
              onChange={handleParametersChange('block_responses')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Check
              type="switch"
              id="block-candidacies"
              label="Lock election candidacies"
              checked={meeting.parameters.global.block_candidacies ?? false}
              onChange={handleParametersChange('block_candidacies')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Check
              type="switch"
              id="candidate-once"
              label="Only one candidacy for office and council"
              checked={meeting.parameters.global.candidate_once ?? false}
              onChange={handleParametersChange('candidate_once')}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Settings;
